<div class="financial">
  <div class="tabs" role="tablist" aria-label="Financial views">
    <button type="button" role="tab" [class.active]="tab === 'sales'" [attr.aria-selected]="tab === 'sales'" (click)="selectTab('sales')">Sales Invoices</button>
    <button type="button" role="tab" [class.active]="tab === 'disbursements'" [attr.aria-selected]="tab === 'disbursements'" (click)="selectTab('disbursements')">Disbursements</button>
  </div>

  <ng-container *ngIf="tab === 'sales'">
    <app-saved-search
      class="saved-views"
      #savedSearch
      [gridApi]="gridApi"
      [viewFilterType]="viewFilterType"
      [module]="module"
      [pinnedColumns]="pinnedColumns"
      (onClearFilters)="clearFiltersExternally()"
    ></app-saved-search>

    <div class="toolbar">
      <div class="toolbar-left">
        <form class="search" (submit)="$event.preventDefault(); onSearch(searchInput.value)">
          <div class="search-field">
            <span class="search-icon">
              <img src="assets/icons/data-table/search.svg" alt="" width="16" height="16" />
            </span>
            <input
              #searchInput
              type="search"
              [value]="searchText"
              [class.has-clear]="searchDraft"
              placeholder="Search by description..."
              aria-label="Search by description"
              (input)="searchDraft = searchInput.value"
            />
            <button *ngIf="searchDraft" type="button" class="clear-btn clear-btn--search" aria-label="Clear search" (click)="clearSearch(searchInput)">
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>
          <button type="submit" class="btn-orange btn-orange--search">Search</button>
        </form>

        <div class="date-filter" ngbDropdown #dateDrop="ngbDropdown" autoClose="outside" display="static" (openChange)="$event && datePicker.revertToValue()">
          <button type="button" class="date-filter-btn" [class.has-clear]="hasDateFilter" ngbDropdownToggle>
            <span>{{ dateLabel }}</span>
            <img src="assets/icons/data-table/calendar.svg" alt="" width="18" height="18" />
          </button>
          <button *ngIf="hasDateFilter" type="button" class="clear-btn clear-btn--date" aria-label="Clear date filter" (click)="onDateCleared()">
            <i class="bi bi-x-lg" aria-hidden="true"></i>
          </button>
          <div class="dropdown-menu date-filter-menu" ngbDropdownMenu>
            <app-date-picker
              #datePicker
              mode="single"
              [range]="true"
              [value]="selectedRange"
              (apply)="onDateApplied($event); dateDrop.close()"
              (clear)="onDateCleared(); dateDrop.close()"
            ></app-date-picker>
          </div>
        </div>

        <div class="date-filter status-filter" ngbDropdown autoClose="outside" display="static">
          <button type="button" class="date-filter-btn" [class.has-clear]="statusSelected.length" ngbDropdownToggle aria-label="Status">
            <span class="status-label">
              <img src="assets/icons/data-table/filter.svg" alt="" width="16" height="16" />
              {{ statusLabel }}
            </span>
            <img class="chevron" src="assets/icons/data-table/chevron.svg" alt="" width="10" height="6" />
          </button>
          <button *ngIf="statusSelected.length" type="button" class="clear-btn clear-btn--status" aria-label="Clear status filter" (click)="clearStatuses()">
            <i class="bi bi-x-lg" aria-hidden="true"></i>
          </button>
          <div class="dropdown-menu status-menu" ngbDropdownMenu>
            <label *ngFor="let option of statusOptions" class="status-option">
              <input type="checkbox" [checked]="statusSelected.includes(option.value)" (change)="toggleStatus(option.value)" />
              {{ option.label }}
            </label>
          </div>
        </div>
      </div>

      <div class="toolbar-right toolbar-right--desktop">
        <!-- TODO: Send to Xero stays disabled until its endpoint exists; no endpoint is called. -->
        <button type="button" class="btn-orange" [disabled]="exporting" [attr.aria-busy]="exporting" title="Export Report to CSV" (click)="exportCsv()">
          Export CSV
          <span *ngIf="exporting" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          <img *ngIf="!exporting" src="assets/icons/data-table/download.svg" alt="" width="16" height="16" />
        </button>
        <button type="button" class="btn-orange" disabled title="Not available yet">
          Send to Xero
          <img src="assets/icons/data-table/download.svg" alt="" width="16" height="16" />
        </button>
      </div>
    </div>

    <!-- Desktop: AG Grid. Mobile: invoice cards (same page of data). -->
    <ag-grid-angular
      tkGrid
      class="financial-grid financial-grid--desktop"
      style="height: 600px; width: 100%"
      [gridOptions]="gridOptions"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [appSavedSearchSync]="savedSearch"
      (gridReady)="onGridReady($event)"
      (paginationChanged)="onPaginationChanged()"
      (filterChanged)="onFilterChanged()"
    ></ag-grid-angular>

    <div class="invoice-cards" aria-label="Sales invoices">
      <div *ngIf="mobileLoading" class="invoice-cards__state" aria-busy="true" aria-label="Loading invoices">
        <div class="invoice-card invoice-card--skeleton" *ngFor="let _ of [1, 2, 3]"></div>
      </div>
      <p *ngIf="!mobileLoading && mobileRows.length === 0" class="invoice-cards__empty">No sales invoices to show.</p>
      <article *ngFor="let row of mobileRows; trackBy: trackCard" class="invoice-card">
        <header class="invoice-card__header">
          <div class="invoice-card__ids">
            <span class="invoice-card__title">{{ cardTitle(row) }}</span>
            <!-- Figma 6186:5776 — category · date directly under booking id -->
            <span *ngIf="cardMeta(row)" class="invoice-card__meta">{{ cardMeta(row) }}</span>
          </div>
          <span *ngIf="statusLabelFor(row)" class="fin-badge" [ngClass]="'fin-badge--' + statusTone(row)">
            <span class="fin-dot" aria-hidden="true"></span>
            {{ statusLabelFor(row) }}
          </span>
        </header>
        <dl class="invoice-card__breakdown">
          <div>
            <dt>Gross</dt>
            <dd>{{ money(row.sales_amount) }}</dd>
          </div>
          <div>
            <dt>Truckit Fee</dt>
            <dd>{{ money(row.truckit_fee) }}</dd>
          </div>
          <div>
            <dt>Net</dt>
            <dd>{{ money(row.amount) }}</dd>
          </div>
        </dl>
        <footer class="invoice-card__footer">
          <button
            *ngIf="canOpenReceipt(row); else paidOutStatic"
            type="button"
            class="fin-badge fin-badge--clickable"
            [ngClass]="'fin-badge--' + paymentTone(row)"
            (click)="openDisbursementReport(row)"
          >
            <span class="fin-dot" aria-hidden="true"></span>
            {{ paymentLabel(row) }}
            <i class="bi bi-file-earmark-text fin-badge__icon" aria-hidden="true"></i>
          </button>
          <ng-template #paidOutStatic>
            <span class="fin-badge" [ngClass]="'fin-badge--' + paymentTone(row)">
              <span class="fin-dot" aria-hidden="true"></span>
              {{ paymentLabel(row) }}
            </span>
          </ng-template>
          <div class="invoice-card__actions">
            <button *ngIf="canOpenReceipt(row)" type="button" class="invoice-card__link" (click)="openDisbursementReport(row)">View Receipt</button>
            <button
              type="button"
              class="btn-orange btn-orange--pdf"
              [disabled]="isInvoiceBusy(row.booking_id)"
              [attr.aria-label]="'Download invoice PDF for booking ' + row.booking_id"
              (click)="downloadInvoice(row)"
            >
              <span *ngIf="isInvoiceBusy(row.booking_id)" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              <ng-container *ngIf="!isInvoiceBusy(row.booking_id)">
                PDF
                <img src="assets/icons/data-table/download.svg" alt="" width="14" height="14" />
              </ng-container>
            </button>
          </div>
        </footer>
      </article>
      <nav *ngIf="!mobileLoading && mobileTotal > 0" class="invoice-pager" aria-label="Invoice pages">
        <button type="button" class="invoice-pager__btn" aria-label="Previous page" [disabled]="mobilePage <= 1" (click)="goToMobilePage(mobilePage - 1)">‹</button>
        <span class="invoice-pager__page is-active" aria-current="page">{{ mobilePage }}</span>
        <button type="button" class="invoice-pager__btn" aria-label="Next page" [disabled]="mobilePage >= mobilePageCount" (click)="goToMobilePage(mobilePage + 1)">›</button>
      </nav>
    </div>
  </ng-container>

  <!-- Mounted only while this tab is open, so the payouts are fetched when it is first opened. -->
  <app-disbursements *ngIf="tab === 'disbursements'"></app-disbursements>
</div>
